import SocketContext from 'context/socket/SocketContext'
import { selectUser } from 'containers/Login/loginSlice'
import React, { useContext, useState } from 'react'
import useTranslation from 'hooks/useTranslation'
import { useDispatch } from 'react-redux'
import { addMessage } from '../chatSlice'
import { useReduxSelector } from 'store'
import { getUuid } from 'utils/uuid'
import Paperclip from './Paperclip'
import { POST } from 'rest/request'
import { api } from 'rest/urls'
import { v7 } from 'uuid'

interface InputProps {
  disabled?: boolean
  chat_id: string
}

const Input: React.FC<InputProps> = ({ chat_id, disabled }) => {
  const [files, setFiles] = useState<FileList | null>(null)
  const [isLoading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const user = useReduxSelector(selectUser)

  const dispatch = useDispatch()
  const { t } = useTranslation('form')
  const { sendMessage } = useContext(SocketContext)

  const isDisabled = disabled || isLoading

  const send = () => {
    if (isLoading) return
    if (files) sendFiles()
    if (message) sendTextMessage()
  }

  const sendTextMessage = async () => {
    const query = new URLSearchParams(window.location.search)
    const warehouseId = query.get('warehouseId')
    const id = v7()
    const payload: basic.Form = {
      receiver: 'SERVICE',
      chat_title: t('hiHowCanWeHelpYou'),
      message,
      chat_id,
      id
    }
    if (warehouseId) {
      payload.relatedObject = 'Warehouse'
      payload.relatedId = warehouseId
    }
    dispatch(addMessage({
      isSender: true,
      message,
      chat_id,
      id,
      _from: {
        userID: typeof user?.id === 'string' ? user.id : '',
        userName: user?.name,
        device: getUuid()
      }
    }))
    sendMessage({
      command: 'sendMessage',
      payload
    })
    setMessage('')
  }

  const sendFiles = async () => {
    if (!files) return
    setLoading(true)
    const formData = new FormData()
    Array.from(files).forEach((file, idx) => formData.append(`file[${idx}]`, file))
    formData.append('receiverSocketId', 'SERVICE')
    formData.append('channel', 'chat')
    formData.append('chatId', chat_id)

    try {
      const response: chat.NewFiles = await POST(`${api}callservice/upload`, { form: formData })
      setLoading(false)
      if (Array.isArray(response)) {
        dispatch(addMessage({
          isSender: true,
          message: '',
          chat_id,
          files: response,
          _from: {
            userID: typeof user?.id === 'string' ? user.id : '',
            userName: user?.name,
            device: getUuid()
          }
        }))
        setFiles(null)
      }

    } catch (error) {
      console.error('Sending files failed', error)
      setLoading(false)
    }
  }

  return (
    <div
      className='chat__input center'
      style={isDisabled ? { opacity: 0.5 } : undefined}>

      <Paperclip
        disabled={isDisabled}
        setFiles={setFiles}
        length={files?.length} />

      <div className='input__main'>
        <textarea
          rows={1}
          value={message}
          disabled={isDisabled}
          placeholder={t('writeMessage')}
          onKeyDown={e => e.key === 'Enter' && !e.shiftKey && send()}
          onChange={e => e.target.value !== '\n' && setMessage(e.target.value)}
        />

        <svg xmlns="http://www.w3.org/2000/svg" width="20.551" height="20.551" viewBox="0 0 20.551 20.551" onClick={send} style={isDisabled ? { opacity: 0.5 } : undefined}>
          <g id="send" transform="translate(0.75 0.734)">
            <line id="Line_1" data-name="Line 1" x1="10" y2="10" transform="translate(8.525 0.542)" fill="none" stroke="var(--theme-text)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
            <path id="Path_3" data-name="Path 3" d="M21.051,2,14.383,21.051l-3.81-8.573L2,8.668Z" transform="translate(-2 -1.984)" fill="none" stroke="var(--theme-text)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
          </g>
        </svg>
      </div>
    </div>
  )
}

export default Input